export default __webpack_public_path__ + "static/media/location.f4cbf172.png";